import { Check, X } from 'lucide-react';

const rows = [
  { feature: 'Logic', standard: 'Reactive (Post-claim)', link: 'Proactive (Pre-export)' },
  { feature: 'Authority', standard: 'Algorithm-suggested', link: 'Surgeon-confirmed' },
  { feature: 'Compliance', standard: 'High-risk "upsell" logic', link: 'Zero-suggest policy' },
  { feature: 'Data Integrity', standard: 'Probability-based', link: 'Evidence-linked' },
];

export function IntegrityTableSection() {
  return (
    <section className="py-20 md:py-28 bg-background">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="text-center mb-12 md:mb-14">
          <p className="text-xs font-semibold tracking-widest uppercase text-primary mb-4">
            Competitive Advantage
          </p>
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground mb-6">
            The Integrity Table
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            See how LINK's closed-loop approach compares to traditional RCM and
            automated coding platforms.
          </p>
        </div>

        {/* Desktop table */}
        <div className="hidden md:block max-w-4xl mx-auto">
          <div className="rounded-xl border border-border overflow-hidden bg-card">
            <table className="w-full">
              <thead>
                <tr className="border-b border-border">
                  <th className="text-left text-xs uppercase tracking-wider text-muted-foreground font-semibold px-6 py-4 w-[22%]">
                    Feature
                  </th>
                  <th className="text-left text-xs uppercase tracking-wider text-muted-foreground font-semibold px-6 py-4 w-[39%]">
                    <span className="flex items-center gap-2">
                      <X className="h-3.5 w-3.5 text-destructive" strokeWidth={2.5} />
                      Standard RCM / Auto Coding
                    </span>
                  </th>
                  <th className="text-left text-xs uppercase tracking-wider text-primary font-semibold px-6 py-4 w-[39%]">
                    <span className="flex items-center gap-2">
                      <Check className="h-3.5 w-3.5 text-primary" strokeWidth={2.5} />
                      LINK Revenue Integrity
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row, i) => (
                  <tr
                    key={row.feature}
                    className={`border-b border-border last:border-b-0 transition-colors hover:bg-secondary ${
                      i % 2 === 0 ? 'bg-transparent' : 'bg-secondary/50'
                    }`}
                  >
                    <td className="px-6 py-4 text-sm font-semibold text-foreground">{row.feature}</td>
                    <td className="px-6 py-4 text-sm text-muted-foreground">{row.standard}</td>
                    <td className="px-6 py-4 text-sm text-primary font-medium">{row.link}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Mobile cards */}
        <div className="md:hidden space-y-4 max-w-lg mx-auto">
          {rows.map((row) => (
            <div key={row.feature} className="rounded-xl border border-border bg-card p-5">
              <p className="text-xs uppercase tracking-wider text-muted-foreground font-semibold mb-3">
                {row.feature}
              </p>
              <div className="space-y-2.5">
                <div className="flex items-start gap-2.5">
                  <X className="h-4 w-4 text-destructive mt-0.5 shrink-0" strokeWidth={2} />
                  <span className="text-sm text-muted-foreground">{row.standard}</span>
                </div>
                <div className="flex items-start gap-2.5">
                  <Check className="h-4 w-4 text-primary mt-0.5 shrink-0" strokeWidth={2} />
                  <span className="text-sm text-primary font-medium">{row.link}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
